import { useDeprecationWarning } from "@jutro/platform";
import { createContext, useContext } from "react";
export var FooterDeprecationContext = createContext(void 0);
export var useFooterDeprecationMessage = function (componentName) {
  var noDeprecationWarnings = useContext(FooterDeprecationContext);
  useDeprecationWarning({
    componentName: componentName,
    noDeprecationWarnings: noDeprecationWarnings
  });
};